import styled from 'styled-components'

export const Messages = styled.ul`
  text-align: left;
`

export const Message = styled.li`
  ${({ theme }) => theme.textStyles.text}
  color: ${({ theme }) => theme.colors.red};
  text-align: left;
`
